<div class="production-db-content" dir="{{languageDir}}">
    <div class="content-top-box">
      <ul class="breadcrumb">
        <ul class="breadcrumb">
          <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
            <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
              (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
          </li>
        </ul>
      </ul>
      <div class="title-row-flex-both-end">
        <h1 class="main-title">{{langObj ? langObj?.energyDashBoard : ('energyDashBoard' | translate)}}</h1>
      </div>
    </div>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
    <form [formGroup]="engDashboardForm">
      <div class="content-top-row content-top-row-order-processing">
        <!-- GROUP -->
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <!-- <mat-label>Status</mat-label> -->
          <mat-select formControlName="UserGroup1" (selectionChange)="onChangeGroup($event)"
            placeholder="{{langObj ? langObj?.Group : ('Group' | translate)}}" panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'EG_Desc'" [array]="GroupList"
              (filteredReturn)="filteredGroups = $event"></mat-select-filter>
            <mat-option *ngFor="let group of filteredGroups" [value]="group.EG_Id">
              {{group.EG_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="UserPlant1" (selectionChange)="onChangePlant($event)"
            placeholder="{{langObj ? langObj?.Plant : ('Plant' | translate)}}" panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'PT_Desc'" [array]="PlantList1"
              (filteredReturn)="filteredPlants = $event"></mat-select-filter>
            <mat-option *ngFor="let plant of filteredPlants" [value]="plant.PT_Id">
              {{plant.PT_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="line" (selectionChange)="onChangeLine($event)"
            placeholder="{{langObj ? langObj?.Line : ('Line' | translate)}}" panelClass="testClass" name="line">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'PL_Desc'" [array]="lineList"
              (filteredReturn)="filteredLines = $event"></mat-select-filter>
            <mat-option *ngFor="let line of filteredLines" [value]="line.PL_Id">
              {{line.PL_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="unit" placeholder="{{langObj ? langObj?.Unit : ('Unit' | translate)}}"
            panelClass="testClass" name="unit" (selectionChange)="onSubmit()">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'PU_Desc'" [array]="unitList"
              (filteredReturn)="filteredUnits = $event"></mat-select-filter>
            <mat-option *ngFor="let unit of filteredUnits" [value]="unit.PU_Id">
              {{unit.PU_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-select formControlName="interval" placeholder="{{langObj ? langObj?.timeSeriesInterval : ('timeSeriesInterval' | translate)}}"
              panelClass="testClass" name="unit" (selectionChange)="onSubmit()">
              <mat-option  [value]=5 >5 Minutes</mat-option>
              <mat-option  [value]=15>15 Minutes</mat-option>
              <mat-option  [value]=30>30 Minutes</mat-option>
              <mat-option  [value]=60>1 hour</mat-option>
            </mat-select>
          </mat-form-field>
      </div>
      <!-- Dropdown -->
      <div class="content-top-row content-top-row-order-processing">
        <div class="inputField">
          <nz-date-picker class="calender-input" id="startPicker" formControlName="dateStart" nzFormat="dd/MM/yyyy HH:mm"
            [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
          <span class="floating-text">{{langObj ? langObj?.StartDate : ('StartDate' | translate)}}</span>
        </div>
        <div class="inputField">
          <nz-date-picker class="calender-input" id="endPicker" formControlName="dateEnd" nzFormat="dd/MM/yyyy HH:mm"
            [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
          <span class="floating-text">{{langObj ? langObj?.EndDate : ('EndDate' | translate)}}</span>
        </div>
        <div class="btn-position">
          <button type="submit" class="icon-btn" matTooltipClass="custom-tooltip" matTooltip="Apply Filter"
            (click)="onSubmit()" tooltipPosition="top">
            <img src="assets/images/search.png" alt="" width="20px" height="20px">
          </button>
        </div>
      </div>
          <div class="menu-card-group" style="align-items: center">
            <div class="menu-card-item mat-card-height overview-cart" style="background-color: #09bc80;border: white ;height: 90px">
              <p class="title-text">{{langObj ? langObj?.totalpower : ('totalpower' | translate)}}</p>
              <p><span class="data-text">{{totalPower}}</span><span style="color: white; font-weight: bold;"> kW</span></p>
           
              <!-- <div class="menu-bottom-icon">
                <img class="img" [src]="menuRedIconUrl" alt="{{ menuRedIconUrl }}" />
              </div> -->
            </div>
      
            <div class="menu-card-item mat-card-height overview-cart" style="background-color: #d10f59;border: white ;height: 90px">
              <p class="title-text">{{langObj ? langObj?.current : ('current' | translate)}}</p>
              <p ><span class="data-text"> {{totalCurrent}}</span><span style="color: white; font-weight: bold;"> Amp</span></p>
            
              <!-- <div class="menu-bottom-icon">
                <img class="img" [src]="menuRedIconUrl" alt="{{ menuRedIconUrl }}" />
              </div> -->
            </div>
            <div class="menu-card-item mat-card-height overview-cart" style="background-color: #0f0fd1;border: white;height: 90px ">
                <p class="title-text">{{langObj ? langObj?.voltage : ('voltage' | translate)}}</p>
                <p><span class="data-text"> {{totalVoltage}}</span><span style="color: white; font-weight: bold;"> V</span></p>
              
                <!-- <div class="menu-bottom-icon">
                  <img class="img" [src]="menuRedIconUrl" alt="{{ menuRedIconUrl }}" />
                </div> -->
              </div>
            </div>
            <div class="chart-group">
                <div class="chart-items" style="width: 100%;">
                    <div class="chart-title">{{langObj ? langObj?.totalpower : ('totalpower' | translate)}}</div>
                    <div [chart]="totalPowerChart"></div>
                </div>
            </div>
            <div class="chart-group">
                <div class="chart-items">
                    <div class="chart-title">{{langObj ? langObj?.current : ('current' | translate)}}</div>
                    <div id="totalCurrentChart"></div>
                    <!-- <mat-spinner-button [options]="spinnerButtonOptions1"
                    class="loader" id="selectedRows" style="margin: 6px 10px;">
                  </mat-spinner-button> -->
                </div>
          
                <div class="chart-items">
                    <div class="chart-title">{{langObj ? langObj?.voltage : ('voltage' | translate)}}</div>
                    <div id="totalVoltageChart"></div>
                </div>
            </div>
        
      </form>
      </div>
      